export interface ListProps<T> {
  dataSource: T[]
  renderItem: (dataSource: T, index: number) => React.ReactNode
}

export function List<T>({ dataSource, renderItem }: ListProps<T>): React.ReactElement {
  return <>{dataSource.map((data, index): React.ReactNode => renderItem(data, index))}</>
}
